/* eslint-disable */
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { AlertAdapter, RegularButton, CommonInput, CommonDropdown, ICommonDropdownOption } from 'pg-ui-library';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import ChatFaqService from 'src/services/chat-bot-faq.service';
import { useAddFaq, useUpdateFaq } from '../mutations/add-update-faq';
import {
  ReopenTicketForm,
  ReopenTicketBody,
  ReopenTicketHeader,
  ReplyTextarea,
  ReopenFooter,
  ReopenLabel,
} from './styles';

interface FaqModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  faqData?: any;
  refetch: () => void;
}

const mytypeOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'General',
    value: 'General',
  },
  {
    key: '2',
    label: 'benefits',
    value: 'benefits',
  },
  {
    key: '3',
    label: 'hr profile',
    value: 'hr profile',
  },
  {
    key: '4',
    label: 'tax forms',
    value: 'tax forms',
  },
  {
    key: '5',
    label: 'payroll',
    value: 'payroll',
  },
];

export const FaqModal: React.FC<FaqModalProps> = ({ isOpen, setIsOpen, faqData, refetch }) => {
  const isEditing = !!faqData;

  const handleModalClose = () => {
    setIsOpen(false);
  };
  const [faqtype, setFaqtype] = useState('');
  const [status, setStatus] = useState('');

  const addFaq = useAddFaq();
  const UpdateFaq = useUpdateFaq();
  const [faqId, setFaqId] = useState();

  useEffect(() => {
    setFaqId(faqData?.id);
  });

  const validationSchema = yup.object().shape({
    question: yup.string().required('Question is required'),
    answer: yup.string().required('Answer is required'),
    redirectUrl: yup.string().url('Must be a valid URL').optional(),
    reviewed: yup.boolean().required(),
  });

  const formik = useFormik({
    initialValues: {
      question: faqData?.question || '',
      answer: faqData?.answer || '',
      redirectUrl: faqData?.redirectUrl || '',
      reviewed: faqData?.reviewed || false,
      category: faqData?.category || '',
    },
    validationSchema,
    onSubmit: async values => {
      try {
        if (isEditing) {
          if (!faqId) {
            throw new Error('faqId is required');
          }
          await UpdateFaq.mutateAsync({ faqId, faq: values });
          AlertAdapter('FAQ updated successfully', 'success');
        } else {
          console.log('here it is coming', values);
          await addFaq.mutateAsync({ faq: values });
          AlertAdapter('FAQ created successfully', 'success');
        }
        refetch();
        handleModalClose();
      } catch (error) {
        console.log('error', error);
        AlertAdapter('Something went wrong', 'error');
      }
    },
    enableReinitialize: true,
  });

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModalClose}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '700px',
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '40px',
          background: '#F3F4F8',
          overflowY: 'auto',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <ReopenTicketHeader>
          <h3>{isEditing ? 'Update FAQ' : 'Create FAQ'}</h3>
          <CloseIcon src={closeSvg} onClick={handleModalClose} />
        </ReopenTicketHeader>
        <ReopenTicketBody>
          <ReopenLabel>Question</ReopenLabel>
          <ReplyTextarea
            placeholder="Enter question..."
            value={formik.values.question}
            onChange={e => formik.setFieldValue('question', e.target.value)}
          />

          <ReopenLabel>Answer</ReopenLabel>
          <ReplyTextarea
            placeholder="Enter answer..."
            value={formik.values.answer}
            onChange={e => formik.setFieldValue('answer', e.target.value)}
          />

          <ReopenLabel>Answer</ReopenLabel>
          <CommonDropdown
            label=""
            id="statusTicket"
            name="statusTicket"
            options={mytypeOptions}
            // value={faqtype}
            // setValue={(value: string) => {
            //   setFaqtype(value);
            //   setStatus(value);
            // }}

            value={formik.values.category}
            setValue={(value: string) => {
              formik.setFieldValue('category', value);
            }}
            selectStyle={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />

          <ReopenLabel>Redirect URL (optional)</ReopenLabel>
          <CommonInput
            id="personnelNumber"
            name="personnelNumber"
            label=""
            placeholder="url"
            value={formik.values.redirectUrl}
            onChange={e => formik.setFieldValue('redirectUrl', e.target.value)}
            style={{ width: '100%' }}
          />

          <ReopenFooter>
            <RegularButton
              type="button"
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
              onClick={handleModalClose}
            >
              Cancel
            </RegularButton>
            <RegularButton type="submit" disabled={formik.isSubmitting || !formik.isValid}>
              {isEditing ? 'Update' : 'Create'}
            </RegularButton>
          </ReopenFooter>
        </ReopenTicketBody>
      </ReopenTicketForm>
    </ReactModal>
  );
};
